export default "__VITE_ASSET__CNHG0GvR__"